import { create } from 'zustand';

type CampaignModalState = {
	isOpen: boolean;
	setOpen: (open: boolean) => void;
	open: () => void;
	close: () => void;
};

export const useCampaignModalStore = create<CampaignModalState>((set) => ({
	isOpen: false,
	setOpen: (open) => set({ isOpen: open }),
	open: () => set({ isOpen: true }),
	close: () => set({ isOpen: false }),
}));
